<template>
	<div class="app-main">
		<el-row type="flex" class="app-main-header" align="middle">
			<el-col :span="6">
				<div class="router-title">
					<i class="el-icon-s-home"></i><span style="margin-left: 5px;">{{$route.meta.title}}</span>
				</div>
			</el-col>
			<el-col :span="18" class="app-main-header-btns">
				<el-button size="small" type="danger" icon="el-icon-delete" @click="handleClear"
					v-hasPermi="['system:sysOperLog:clear']">清空
				</el-button>
				<el-button size="small" type="success" icon="el-icon-download" @click="handleExport"
					v-hasPermi="['system:userLoginLog:export']">导出
				</el-button>
			</el-col>
		</el-row>
		<el-row class="mg-b5">
			<el-card class="box-card">
				<div slot="header" class="clearfix">
					<el-form :inline="true" class="demo-form-inline">
						<el-form-item class="my-form-item">
							<el-date-picker size="mini" :unlink-panels="true" type="daterange" range-separator="-"
								v-model="quertInfo.searchTime" start-placeholder="开始日期" value-format="yyyy-MM-dd"
								style="width: 200px" end-placeholder="结束日期">
							</el-date-picker>
						</el-form-item>
						<el-form-item class="my-form-item">
							<el-select size="mini" clearable style="width: 100px" v-model="quertInfo.objMap.status"
								placeholder="选择状态">
								<el-option label="成功" value="0"></el-option>
								<el-option label="失败" value="1"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item class="my-form-item">
							<el-input size="mini" placeholder="请输入查询条件" clearable v-model="quertInfo.objMap.search"
								style="width: 160px" prefix-icon="el-icon-search"></el-input>
						</el-form-item>
						<el-form-item class="my-form-item">
							<el-button size="mini" type="primary" icon="el-icon-search" @click="onSearch"
								v-hasPermi="['system:userLoginLog:query']">查询
							</el-button>
						</el-form-item>
					</el-form>
				</div>
				<el-table :data="tableData" border size="mini" :header-cell-style="headerCellStyle"
					:height="tableHeight()">
					<el-table-column prop="username" label="用户账号" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column prop="status" label="登陆状态" :formatter="formatStatus"></el-table-column>
					<el-table-column prop="ip" label="登陆IP地址" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column prop="loginLocation" label="登录地点" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column prop="os" label="操作系统" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column prop="browser" label="浏览器类型" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column prop="msg" label="提示消息" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column prop="createTime" label="登录时间" width="140"></el-table-column>
					<el-table-column label="操作" width="100">
						<template slot-scope="scope">
							<el-button type="text" icon="el-icon-delete" size="small" @click="handleDel(scope.row.id)"
								v-hasPermi="['system:userLoginLog:del']">删除
							</el-button>
						</template>
					</el-table-column>
				</el-table>
				<el-row type="flex" justify="end" class="mg-t5">
					<pagination v-show="count>0" @on-pagination="onPagination" :page.sync="quertInfo.page"
						:limit.sync="quertInfo.limit" :total="count">
					</pagination>
				</el-row>
			</el-card>
		</el-row>
	</div>
</template>

<script>
	import {
		userLoginLogList,
		clearUserLoginLog,
		delUserLoginLog
	} from '@/api/system/userLoginLog.js'

	export default {
		name: "UserLoginLog",
		computed: {},
		data() {
			return {
				title: "",
				tableData: [],
				form: {},
				count: 0,
				quertInfo: {
					page: 1, //当前页码
					limit: 20, //当前每页显示的数量
					searchTime: [],
					objMap: {
						search: ''
					}
				},
			};
		},
		created() {
			this.getList();
		},
		methods: {
			onPagination: function(val) {
				this.quertInfo.page = val.page;
				this.quertInfo.limit = val.limit;
				this.getList()
			},
			async getList() {
				let _this = this;
				const {
					data: res
				} = await userLoginLogList(_this.quertInfo)
				if (res.code == 0) {
					_this.tableData = res.data;
					_this.count = res.count;
				} else {
					_this.$fail(res.msg);
				}
			},
			onSearch: function() {
				//重置页码（会出现查询搜索字段在当前页码之前，会查询不到）
				this.quertInfo.page = 1;
				this.getList();
			},
			handleClear: function() {
				let _this = this;
				_this.confirm({
					text: '确认清空所有数据吗',
					tip: '警告',
					type: '',
					fn: function(param) {
						clearUserLoginLog().then(response => {
							if (response.data.code === 0) {
								_this.$success(response.data.msg);
								_this.getList();
							} else {
								_this.$fail(response.data.msg);
							}
						});
					},
				});
			},
			handleDel: function(id) {
				let _this = this;
				_this.confirm({
					text: '确认删除吗',
					tip: '警告',
					type: '',
					fn: function(param) {
						delUserLoginLog(param).then(response => {
							if (response.data.code === 0) {
								_this.$success(response.data.msg);
								_this.getList();
							} else {
								_this.$fail(response.data.msg);
							}
						});
					},
					data: {
						id: id
					} //参数对象 主要回调函数用
				});
			},
			handleExport: function() {
				let _this = this;
				_this.confirm({
					text: '导出当前页，还是全部导出',
					but1: '全部导出',
					but2: '当前页',
					type: '',
					fn: function() {
						let param = JSON.parse(JSON.stringify(_this.quertInfo));
						param.page = 0;
						exportUserLoginLog(param).then(response => {
							if (response.data.code === 0) {
								_this.download(response.data.data);
							} else {
								_this.$fail(response.data.msg);
							}
						});
					},
					cancel: function() {
						exportUserLoginLog(_this.quertInfo).then(response => {
							if (response.data.code === 0) {
								_this.download(response.data.data);
							} else {
								_this.$fail(response.data.msg);
							}
						});
					},
				});
			},
			formatStatus: function(row) {
				return row.status == 0 ? '成功' : '失败';
			}
		}
	};
</script>
<style scoped="scoped">
</style>
